export enum ChartOfAccountsHelpAnchor {
    AccountType,
    AccountNumber,
    AddingAccounts,
    DefaultAccounts,
    ImportingAccounts,
    EditExistingAccounts,
    MovingTransactions,
    DeletingItems,
    InactivatingAccounts,
    RemovingAccountNumbers
}
